// eslint-disable-next-line import/extensions,import/no-unresolved
import Service from 'vuex-photoprism-service-api';

export function service(token) {
  return new Service({
    baseURL: process.env.API_GO_HOST,
    token: token ? token.replace("Bearer ", "")  : process.env.API_GO_TOKEN,
  });
}

export default service;




// WEBPACK FOOTER //
// ./src/services/index.js